import useTableRequest from "../../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { provinceSalesReportsColumns } from "../../../constant/tables-columns/tablesColums";
import { digitsThree } from "../../../utils/price";
import UserReportsFilter from "./ProvinceReportsFilter";
import ExportExcel from "../../../components/common/export-exel/ExportExel";

export default function ProvinceSalesReports() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [userReportsData, setUsersReportsData] = useState([]);

  const getProductReports = async (params) => {
    const path = "admin/reports/salesSummaryByProvince";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setUsersReportsData(response?.data?.result);
    });
  };

  useEffect(() => {
    getProductReports({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };
  const data = [];
  userReportsData?.map((item) =>
    data.push({
      ordersTotalCount: digitsThree(item.ordersTotalCount),
      finalPriceWithoutShippingSum: digitsThree(
        item.finalPriceWithoutShippingSum
      ),
      totalProductsPriceSum: digitsThree(item.totalProductsPriceSum),
      province: item?.province,
    })
  );

  const exportReportsData = [];

  userReportsData?.map((item) =>
    exportReportsData.push({
      نام: item?.province,
      "مجموع تعداد سفارش": item?.ordersTotalCount,
      "مجموع ناخالص": item?.totalProductsPriceSum,
      "مجموع خالص": item?.finalPriceWithoutShippingSum,
    })
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"گزارش خرید استان ها"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel disabled={tableRequest.status !== "success"} jsonData={exportReportsData} />
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">تعداد سفارش و مجموع فروش را به تفکیک استان، بر اساس بازهٔ تاریخ پرداخت نشان می‌دهد.</p>
      <UserReportsFilter filterDataHandler={filterDataHandler} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={provinceSalesReportsColumns} rows={data} />
    </div>
  );
}
